import EntityDocumentsTab from 'components/documents/entity-documents-tab.component'

type CustomerDocumentTabProps = {
  companyId: string
}

const CustomerDocumentTab = ({ companyId }: CustomerDocumentTabProps) => {
  return (
    <EntityDocumentsTab
      associateId={companyId}
      internalType="CarrierDocument"
    />
  )
}

export default CustomerDocumentTab
